"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var ticket_1 = require("../../../api/ticket");
var TicketDeleteButton = function (props) {
    var className = props.className;
    var _a = (0, react_1.useState)(0), ticketId = _a[0], setTicketId = _a[1];
    var _b = (0, react_1.useState)(false), modal = _b[0], setModal = _b[1];
    var toggle = function () { return setModal(!modal); };
    var submitDeleteTicket = function () {
        (0, ticket_1.deleteTicket)(ticketId).then(function (response) {
        });
        toggle();
        props.modalCallback();
    };
    var onLoad = function () {
        var id = 1;
        if (props.id) {
            setTicketId(props.id);
        }
    };
    (0, react_1.useEffect)(function () {
        onLoad();
    }, [ticketId, setTicketId]);
    return (React.createElement("div", null,
        React.createElement(reactstrap_1.Button, { style: { padding: 0 }, color: "link", onClick: toggle },
            React.createElement("a", { className: "padding-default" },
                React.createElement("img", { src: "./delete.svg", className: "font-icon" }))),
        React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, className: className, size: "lg", centered: true },
            React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }),
            React.createElement(reactstrap_1.ModalBody, { id: "delete-body" }, "Are you sure want to delete this?"),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                ' ',
                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: function () { return submitDeleteTicket(); } }, "Yes, Delete")))));
};
exports.default = TicketDeleteButton;
//# sourceMappingURL=TicketDeleteButton.js.map